export default "__VITE_ASSET__BiqqORmN__"